import { PrintJobType } from '@/types'
import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'

export function JobTypeBadge({
  jobType,
  className,
}: {
  jobType: PrintJobType
  className?: string
}) {
  const config: Record<PrintJobType, { bg: string; label: string }> = {
    [PrintJobType.RECEIPT]: {
      bg: 'bg-blue-500/10 text-blue-700 border-blue-500/20',
      label: 'Receipt',
    },
    [PrintJobType.LABEL]: {
      bg: 'bg-teal-500/10 text-teal-700 border-teal-500/20',
      label: 'Label',
    },
    [PrintJobType.RAW]: {
      bg: 'bg-gray-500/10 text-gray-700 border-gray-500/20',
      label: 'Raw',
    },
  }

  const { bg, label } = config[jobType] ?? config[PrintJobType.RAW]

  return (
    <Badge
      variant="outline"
      className={cn('font-medium text-xs whitespace-nowrap', bg, className)}
    >
      {label}
    </Badge>
  )
}
